import { InjectionToken } from '@angular/core';

export type ShipmentsDataConfig = {
  apiPrefix: string;
};

export const SHIPMENTS_DATA_CONFIG = new InjectionToken<ShipmentsDataConfig>(
  'shipments-data-config',
);
